import { Api } from "../config/request";

export default {
  getFleetCoachDriverMappingList(body) {
    return Api.post(`/catalyst/fleet-coach/fleet-coach-driver-mapping`, body);
  },
};
